var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32215_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3.03811C15.4113 3.29945 14.7787 3.47545 14.1147 3.55478C14.7927 3.14878 15.3133 2.50545 15.558 1.73878C14.924 2.11478 14.2213 2.38811 13.4733 2.53545C12.8753 1.89745 12.0213 1.49878 11.0773 1.49878C8.958 1.49878 7.40067 3.47611 7.87933 5.52878C5.152 5.39211 2.73333 4.08545 1.114 2.09945C0.254 3.57478 0.668 5.50478 2.12933 6.48211C1.592 6.46478 1.08533 6.31745 0.643333 6.07145C0.607333 7.59211 1.69733 9.01478 3.276 9.33145C2.814 9.45678 2.308 9.48611 1.79333 9.38745C2.21067 10.6914 3.42267 11.6401 4.86 11.6668C3.48 12.7488 1.74133 13.2321 0 13.0268C1.45267 13.9581 3.17867 14.5014 5.032 14.5014C11.1267 14.5014 14.57 9.35411 14.362 4.73745C15.0033 4.27411 15.56 3.69611 16 3.03811Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32215_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.456f8dd9648bc0697b1e721649d209ec.svg";
export { ForwardRef as ReactComponent };